import httpClient from '@/api/httpClient'
import static_api from '@/api/static.api.js'

const state = {
  drawer: false,
  leftSideSelectedItem: null,

  countryArr: [], // 国家代码
  dictionaryArr: [], // 得到所有字典
  shipTypeArr: [], // 船舶类型
  lsfoTypeArr: [], // 燃料油型号
  lsdoTypeArr: [] // 柴油型号
}

// getters
const getters = {
  getCountryArr: state => {
    return state.countryArr
  }

}

// actions
const actions = {
  // 得到国家代码
  getCountryArr ({ commit, state }) {
    var postJson = {
      OperID: state.operID
    }

    httpClient.post('/auth/PACountryQry', postJson)
      .then((res) => {
        commit('setCountryArr', res.data)
      })
      .catch(function (error) {
      })
  },

  // 得到所有字典 及常用的分类
  getDictionaryArr ({ commit, state }) {
    var postJson = {
      OperID: state.operID
    }

    httpClient.post('/PADictionaryQry', postJson)
      .then((res) => {
        commit('setDictionaryArr', res.data)

        const [shipTypeArr, lsfoTypeArr, lsdoTypeArr] = [[], [], []]
        res.data.forEach(function (element, index, array) {
          if (element.DICTTYPEID == 16004) { // 16004 shipTypeArr
            shipTypeArr.push(element)
          } else if (element.DICTTYPEID == 16011) { // 16011 lsfoTypeArr
            lsfoTypeArr.push(element)
          } else if (element.DICTTYPEID == 16012) { // 16012 lsdoTypeArr
            lsdoTypeArr.push(element)
          }
        })

        commit('setShipTypeArr', shipTypeArr)
        commit('setLsfoTypeArr', lsfoTypeArr)
        commit('setLsdoTypeArr', lsdoTypeArr)
      })
      .catch(function (error) {

      })
  }
} // end actions

// mutations
const mutations = {
  setDrawer (state, payload) {
    state.drawer = payload
  },

  setLeftSideSelectedItem (state, payload) {
    state.leftSideSelectedItem = payload
  },

  setCountryArr (state, payload) {
    state.countryArr = payload
  },

  setDictionaryArr (state, payload) {
    state.dictionaryArr = payload
  },

  setShipTypeArr (state, payload) {
    state.shipTypeArr = payload
  },

  setLsfoTypeArr (state, payload) {
    state.lsfoTypeArr = payload
  },

  setLsdoTypeArr (state, payload) {
    state.lsdoTypeArr = payload
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
